import { render, staticRenderFns } from "./briefIntroduction.vue?vue&type=template&id=a7dc9f4e&scoped=true"
import script from "./briefIntroduction.vue?vue&type=script&lang=js"
export * from "./briefIntroduction.vue?vue&type=script&lang=js"
import style0 from "./briefIntroduction.vue?vue&type=style&index=0&id=a7dc9f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dc9f4e",
  null
  
)

export default component.exports